/**
 * useFieldsConfig Hook
 * 加载和管理字段配置
 */

import { useState, useEffect } from "react";
import {
  getRegulationsFields,
  type FieldConfig,
} from "../../../services/regulationsService";

export const useFieldsConfig = (pageType: "list" | "detail" = "list") => {
  const [fieldsConfig, setFieldsConfig] = useState<FieldConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadFieldsConfig = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getRegulationsFields(pageType);

        if (response.code === 200 && response.data) {
          console.log("✅ Fields configuration loaded:", response.data.fields);
          setFieldsConfig(response.data.fields);
        } else {
          throw new Error(
            response.message || "Failed to load fields configuration"
          );
        }
      } catch (err) {
        console.error("❌ Failed to load fields configuration:", err);
        setError(err instanceof Error ? err : new Error(String(err)));
        setFieldsConfig([]);
      } finally {
        setLoading(false);
      }
    };

    loadFieldsConfig();
  }, [pageType]);

  return { fieldsConfig, loading, error };
};
